<template>
  <div class="page-wrap">
    <div class="page-left">
      <a-form-model
        :model="query"
        ref="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item :label="$t('page_andon_call_type')">
          <a-select
            v-model="query.andonTypeId"
            :placeholder="$t('please_select') + $t('page_andon_call_type')"
            show-search
            optionFilterProp="children"
            allowClear
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in typeList"
              :key="index"
            >
              {{ item.codeAndName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('page_time_analysis_range')">
          <div style="display: flex">
            <a-date-picker
              :placeholder="$t('page_calendar_year')+'-'+$t('page_calendar_month')+'-'+$t('page_calendar_sun')"
              style="width: 110px; flex: 1"
              valueFormat="YYYY-MM-DD"
              v-model="query.startDate"
            >
            </a-date-picker>
            ~
            <a-date-picker
              :placeholder="$t('page_calendar_year')+'-'+$t('page_calendar_month')+'-'+$t('page_calendar_sun')"
              style="width: 110px; flex: 1"
              valueFormat="YYYY-MM-DD"
              v-model="query.endDate"
            >
            </a-date-picker>
          </div>
        </a-form-model-item>
      </a-form-model>
      <div class="tree-wrap">
        <a-tree
          v-model="checkedKeys"
          checkable
          showIcon
          :checkedKeys="checkedKeys"
          :expandedKeys="expendKeys"
          :tree-data="treeData"
          @expand="expandKey"
          @check="onSelectTree"
        >
          <template slot="custom" slot-scope="item">
            {{ item.title }}
            <template v-if="item.expanded">
              <a-icon
                v-if="item.children"
                type="folder-open"
                theme="filled"
                style="
                  color: #4a90e2;
                  font-size: 16px;
                  position: absolute;
                  left: -47px;
                  top: 3px;
                  z-index: 10;
                "
              />
            </template>
            <template v-if="!item.expanded">
              <a-icon
                v-if="item.children"
                type="folder"
                theme="filled"
                style="
                  color: #4a90e2;
                  font-size: 16px;
                  position: absolute;
                  left: -47px;
                  top: 3px;
                  z-index: 10;
                "
              />
            </template>
          </template>
        </a-tree>
      </div>
      <div class="action">
        <a-button type="default" @click="onReset"> {{$t('common_reset')}} </a-button>
        <a-button type="primary" style="margin-left: 10px" @click="onSearch">
          {{$t('common_search')}}
        </a-button>
      </div>
    </div>
    <div v-resize="'x'"></div>
    <div class="page-right">
      <div class="top-action">
        <a-button type="primary" :disabled="!dataList.length" @click="onExport">
          {{$t('export')}}
        </a-button>
      </div>
      <div class="table-wrap">
        <ml-table
          :columns="columns"
          :canChangeColWidth="true"
          :pagination="pagination"
          :loading="loading"
          :data-source="dataList"
          rowKey="id"
          :scroll="{ x: '100%',y:'calc(100vh - 260px)' }"
          @change="changePage"
        >
        </ml-table>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { downloadFile } from "@/utils";
import { DataTreeNode } from "@/utils/array";
import { WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  AndonTypeServiceProxy,
  AndonCallRecordConfirmServiceProxy,
} from "@/service-proxies/app-v2/andon.service-proxies";
import { andonCallRecordConfirmExport } from "@/api/api";
const wsgsp = new WorkStationGroupServiceProxy();
const andonCallRecordConfirmServiceProxy =
  new AndonCallRecordConfirmServiceProxy();
const andonTypeServiceProxy = new AndonTypeServiceProxy();
export default {
  created() {
    let end = dayjs().format('YYYY-MM-DD');
    let start = dayjs(end).subtract(6,'day').format('YYYY-MM-DD');
    this.$set(this.query,'startDate',start);
    this.$set(this.query,'endDate',end);
    this.getAllTypeList();
    this.getTreeList();
    this.getList();
  },
  methods: {
    // 获取类型
    getAllTypeList() {
      andonTypeServiceProxy.getCodeAndName().then((res) => {
        this.typeList = res || [];
      });
    },
    async getTreeList() {
      this.workStatoinItems = [];
      this.expendKeys = [];
      this.checkedKeys = [];

      wsgsp.workStationGroupList().then((res) => {
        if (res) {
          const keys = [];
          const data = res.reduce((total, value) => {
            const key = value.id + "-" + value.parentId;
            total.push({
              ...value,
              key: key,
            });
            return total;
          }, []);

          this.treeData = DataTreeNode.arrayToTree(data);
          this.treeData.map((item) => {
            item.scopedSlots = {
              title: "custom",
            };
            if (item.children && item.children.length) {
              item.children.map((t) => {
                t.scopedSlots = {
                  title: "custom",
                };
                this.getTreeSelect(t, keys);
              });
            } else {
              // if (this.defaultNumberChecked < 5) {
              //   keys.push(item.key);
              //   this.defaultNumberChecked = this.defaultNumberChecked + 1;
              // }
            }
          });

          this.workStatoinItems = data;
          // this.checkedKeys = keys;
          //   this.checkedKeys = tracList.length > 0 ? tracList : keys;
          //   this.handelSearch();
        }
      });
    },
    getTreeSelect(data, arr) {
      if (data.children && data.children.length) {
        data.children.map((m) => {
          m.scopedSlots = {
            title: "custom",
          };
          this.getTreeSelect(m, arr);
        });
      } else {
        // if (this.defaultNumberChecked < 5) {
        //   arr.push(data.key);

        //   this.defaultNumberChecked = this.defaultNumberChecked + 1;
        // }
      }
      return arr;
    },
    expandKey(value) {
      this.expendKeys = value;
    },
    onSelectWorkStation(value) {
      console.log("onSelectWorkStation", value);
    },

    onChangeWorkStation(value) {
      console.log("change", value);
    },
    onSelectTree(value) {
      this.checkedKeys = value;
    },
    // 重置
    onReset() {
      // this.$refs.form.resetFields();
      this.query = {};
      this.checkedKeys = [];
      this.pagination.current = 1;
      this.getList();
    },
    onSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    getParams() {
      if (this.query.startDate && this.query.endDate) {
        if (new Date(this.query.endDate) < new Date(this.query.startDate)) {
          this.$message.warning(this.$t("page_andon_time_tip"));
          return null;
        }
      }
      let workStationIds = [];
      this.workStatoinItems.map((item) => {
        if (this.checkedKeys.includes(item.key) && !item.isGroup) {
          workStationIds.push(item.id);
        }
      });
      let data = {
        andonTypeId: this.query.andonTypeId || "",
        startTime: "",
        endTime: "",
        workStationIds: workStationIds,
      };
      if (this.query.startDate) {
        data.startTime = dayjs(this.query.startDate).format(
          "YYYY-MM-DD 00:00:00"
        );
      }
      if (this.query.endDate) {
        data.endTime = dayjs(this.query.endDate).format("YYYY-MM-DD 23:59:59");
      }
      return data;
    },
    // 获取列表
    getList() {
      let data = this.getParams();
      if(!data) return;
      let { current, pageSize } = this.pagination;
      this.loading = true;
      andonCallRecordConfirmServiceProxy
        .page(data, current, pageSize)
        .then((res) => {
          this.loading = false;
          this.pagination.total = res.total;
          let dataList = res.records;
          if(dataList.length<30){
            let addColumLength = 30 - dataList.length;
            for(let i=0;i<addColumLength;i++){
              dataList.push({})
            }
          }
          this.dataList = dataList;
        }).catch(() => {
          this.loading = false;
        });
    },
    changePage(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList();
    },
    // 导出
    onExport() {
      let data = this.getParams();
      if(!data) return;
      andonCallRecordConfirmExport(data).then(res => {
        let fileName = this.$t('page_andon_call_confirm_record')+'.xlsx'
        downloadFile(res,fileName)
      })
    },
    onSelectRows(selectedKeys, selectedRows) {
      this.selectedKeys = selectedKeys;
    },
    columnClick(record) {
      this.$set(record, "edit", true);
      console.log(record);
    },
    subEdit(record) {
      this.$set(record, "edit", false);
    },
  },
  data() {
    return {
      query: {},
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 18,
      },
      typeList: [],
      workStations: [],
      workStatoinItems: [],
      expendKeys: [],
      defaultNumberChecked: 0,
      treeData: [],
      stateList: [
        {
          label: this.$t('page_andon_call_no_accept'),
          value: "0",
        },
        {
          label: this.$t('page_andon_call_has_accept'),
          value: "1",
        },
        {
          label: this.$t('page_andon_call_finish'),
          value: "2",
        },
      ],
      loading: false,
      columns: [
        {
          dataIndex: "index",
          key: "index",
          title:this.$t('serial_number'),  //  "序号",
          customRender: (_, record, index) => {
            if(record.id){
              return index + 1;
            }else{
              return ''
            }

          },
          width: 50,
        },
        {
          dataIndex: "andonTypeCode",
          title:this.$t('page_andon_call_type_code'),  // "呼叫类型编码",
          width: 150,
        },
        {
          dataIndex: "andonTypeName",
          title:this.$t('page_andon_call_type_name'),  //"呼叫类型名称",
          width: 150,
        },
        {
          dataIndex: "andonReasonCode",
          title: this.$t('page_andon_call_reason_code'),  // "呼叫原因编码",
          width: 150,
        },
        {
          dataIndex: "andonReasonName",
          title:this.$t('page_andon_call_reason_name'),  // "呼叫原因名称",
          width: 150,
        },
        {
          dataIndex: "workStationName",
          title:this.$t('page_andon_call_station'),  // "呼叫工位",
          width: 150,
        },
        {
          dataIndex: "employeeName",
          title:this.$t('page_andon_call_user'), //"呼叫人员",
          width: 150,
        },
        {
          dataIndex: "receiveEmployeeName",
          title:this.$t('page_andon_call_processing_personnel'),  // "处理人员",
          width: 150,
        },
        {
          dataIndex: "responseTime",
          title:this.$t('page_andon_call_response_time'),   //"响应时间",
          width: 150,
          customRender: (text, _record, index) => {
            if(text){
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            }else{
              return ''
            }
          },
        },
        {
          dataIndex: "responseSpendTime",
          title:this.$t('page_andon_call_response_spend_time'),  // "响应时长",
          width: 150,

        },
        {
          dataIndex: "responseEmployeeName",
          title:this.$t('page_andon_call_response_employee_name'),   // "响应人员",
          width: 150,
        },
        {
          dataIndex: "finishTime",
          title:this.$t('page_andon_call_finish_time'),  // "结束时间",
          width: 150,
          customRender: (text, _record, index) => {
            if(text){
              return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            }else{
              return ''
            }
          },
        },
        {
          dataIndex: "callSpendTime",
          title:this.$t('page_andon_call_spend_total_time'), // "呼叫总时长",
          width: 150,
        },
        {
          dataIndex: "fixSpendTime",
          title:this.$t('page_andon_call_fix_spend_time'), // "处理总时长",
          width: 150,
        },
        {
          dataIndex: "finishEmployeeName",
          title:this.$t('page_andon_call_finish_employee_name'), // "完成人员",
          width: 150,
        },
        {
          dataIndex: "description",
          title:this.$t('page_plan_description'),  // "描述",
          width:150
        },
        {
          dataIndex: "remark",
          title:this.$t('remark'), // "备注",
          width: 200,
        },
      ],
      pagination: {
        size: "normal",
        current: 1,
        pageSize:30,
        total: 0,
        showSizeChanger: false,
        showTotal:(total) => {
          let totalStr = this.$t('Total…items').replace('{0}',total)
          return totalStr;
        }
      },
      dataList: [
      ],
      selectedKeys: [],
      checkedKeys: [],
    };
  },
};
</script>
<style lang="less" scoped>
.page-wrap {
  height: 100%;
  display: flex;

  .page-left {
    width: 350px;
    background: #fff;
    height: 100%;
    padding: 8px;
    flex-shrink: 0;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: auto;
    .tree-wrap {
      flex: 1;
      min-width: 300px;
      overflow: auto;
      border: solid 1px #ddd;
      margin-bottom: 10px;
    }
  }

  .page-right {
    flex: 1;
    overflow: auto;
    background: #fff;
    padding: 10px;
  }
}

.action {
  text-align: center;
}

.table-wrap {
  margin-top: 10px;
}

/deep/
  .ant-tree
  li
  span.ant-tree-switcher.ant-tree-switcher_close
  .ant-tree-switcher-icon
  svg {
  transform: rotate(0deg) !important;
}

/deep/ .ant-tree-title {
  position: relative;
}

/deep/ .ant-tree-switcher {
  color: rgba(0, 0, 0, 0) !important;
  position: relative;
  z-index: 99;
}

/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: rgb(255, 241, 184);
}
</style>
